import React from 'react';

import styles from './styles.module.css';
import RefreshIcon from '@/assets/icons/refresh.svg?react';
import DateInput from '@/components/Form/DateInput';

interface AlarmsHistoryFilterProps {
  startDate: string;
  endDate: string;
  defaultEndDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  onLoad: (e?: React.MouseEvent) => void;
  isLoading?: boolean;
}

export const AlarmsHistoryFilter: React.FC<AlarmsHistoryFilterProps> = ({
  startDate,
  endDate,
  defaultEndDate,
  onStartDateChange,
  onEndDateChange,
  onLoad,
  isLoading
}) => {
  return (
    <div className={styles.filterRow} onClick={e => e.stopPropagation()}>
      <label className={styles.filterLabel}>FILTER BY RANGE</label>
      <label className={styles.dateLabel}>START</label>
      <div className={styles.dateInputContainer}>
        <DateInput
          label=""
          value={startDate}
          onChange={onStartDateChange}
          type="datetime-local"
          customClass={styles.dateInput}
          max={endDate}
          variant="compact"
        />
      </div>
      <label className={styles.dateLabel}>END</label>
      <div className={styles.dateInputContainer}>
        <DateInput
          label=""
          value={endDate}
          onChange={onEndDateChange}
          type="datetime-local"
          customClass={styles.dateInput}
          min={startDate}
          max={defaultEndDate}
          variant="compact"
        />
      </div>
      <div
        onClick={e => e.stopPropagation()}
        className={styles.reloadButtonWrapper}
      >
        <button
          className={styles.actionButton}
          type="button"
          onClick={onLoad}
          disabled={isLoading}
        >
          <RefreshIcon className={styles.refreshIcon} />
        </button>
      </div>
    </div>
  );
};
